import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { wrapDispatch } from 'multireducer'
import { withRouter } from 'react-router-dom'

import { CRUDlist, mutateFilterQuery } from '@infotech/crud'
import { omitProps } from '@infotech/base-components'


const CRUDlistEnhanced = compose(
  withRouter,
  connect(null, (dispatch, { config: { entityName } }) => ({
    changeQuery: (query) => wrapDispatch(dispatch, entityName)(mutateFilterQuery(query)),
  })),
  lifecycle({
    componentDidMount() {
      const { match: { params: { id } = {} } = {} } = this.props
      if (id) {
        this.props.changeQuery({ serviceId: [+id] })
      }
    },
  }),
  omitProps([`history`, `location`, `match`, `changeQuery`]),
)(CRUDlist)

export default CRUDlistEnhanced
